import "./Header.scss";
import React, {useContext, useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {UserContext} from "../../contexts/user";
import "./SubNav.scss";
import styled from "@emotion/styled";
import isEmpty from "lodash/isEmpty";
import firebase from "firebase/app";
import defaultCategories from "../../constants/defaultSections";
import HoverComponent from "react-hover-action-delay";
import {getInternalPath} from "../../utils/url";

const Layout = styled.div`
  background: ${({theme}) => (theme.secondaryColor ? theme.secondaryColor : "#003b00")};
  a {
    color: ${({theme}) => (theme.secondaryTextColor ? theme.secondaryTextColor : "#003b00")};
  }

  .link {
    color: ${({theme}) => (theme.secondaryTextColor ? theme.secondaryTextColor : "white")};
  }
  .link.blossom {
    color: #883532;
  }

  .dropdown {
    background: ${({theme}) => (theme.secondaryColor ? theme.secondaryColor : "#003b00")};
    a {
      color: ${({theme}) => (theme.secondaryTextColor ? theme.secondaryTextColor : "white")};
    }
  }

  .subNav {
    color: ${({theme}) => (theme.secondaryTextColor ? theme.secondaryTextColor : "#003b00")};
  }
  .sublink.blossom {
    color: #883532;
  }
  .headingtitle.blossom {
    color: #883532;
  }
`;

const SubNav = ({colors}) => {
  const [categories, setCategories] = useState(null);
  const [headerContent, setHeaderContent] = useState({});
  const [activeNav, setActiveNav] = useState(null);
  const {user} = useContext(UserContext);
  const [openModal, setOpenModal] = useState(false);

  let unmounted = false;

  useEffect(() => {
    if (!unmounted) {
      fetchData();
    }

    return () => {
      unmounted = true;
    };
  }, []);

  const fetchData = async () => {
    const {getStaticDataDoc} = require("../../utils/staticDataApi");
    const doc = await getStaticDataDoc("green-top-nav", ["json"]);
    if (doc?.json) {
      setCategories(doc.json);
    } else {
      setCategories(defaultCategories);
    }
  };

  const dropdownClass = activeNav !== null ? "active dropdown" : "dropdown";

  let categoryData;
  if (activeNav !== null && categories) {
    categoryData = categories[activeNav];
  }

  return (
    <Layout
      className="top-nav admin"
      style={
        user.colors && {
          backgroundColor: user.colors.secondaryColor,
          color: user.colors.preset === "BlossomBytes" ? "#883532" : user.colors.secondaryTextColor,
        }
      }
    >
      {isEmpty(headerContent) && !openModal && (
        <div className="topsubnav">
          <div
            className="main-links"
            style={
              user.colors && {
                backgroundColor: user.colors.secondaryColor,
                color: user.colors.preset === "BlossomBytes" ? "#883532" : user.colors.secondaryTextColor,
              }
            }
          >
            {(user.isAdmin || user.isEditor) && (
              <span className="main-links-item">
                <Link
                  to={"/admin"}
                  className={`link ${user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""}`}
                  onMouseOver={() => setActiveNav(null)}
                >
                  ADMIN
                </Link>
              </span>
            )}
            {user.isEditor && (
              <span className="main-links-item">
                <Link
                  to={"/editor"}
                  className={`link ${user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""}`}
                  onMouseOver={() => setActiveNav(null)}
                >
                  EDITOR
                </Link>
              </span>
            )}
            {categories &&
              isEmpty(headerContent) &&
              categories.map((category, idx) => {
                const internalPath = getInternalPath(category?.href);
                const isInternal = !!internalPath;
                const navClassName = category.sponsor
                  ? `sponsor link ${user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""}`
                  : `link ${user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""}`;

                return (
                  <span key={idx} className="main-links-item">
                    {category.text === "BRAND" ? (
                      <>
                        {user.isBrand &&
                          (isInternal ? (
                            <Link
                              key={idx}
                              to={internalPath}
                              className={navClassName}
                              onMouseOver={() => {
                                category.sections.length > 0 ? setActiveNav(idx) : setActiveNav(null);
                              }}
                            >
                              {category?.text}
                            </Link>
                          ) : (
                            <a
                              key={idx}
                              href={category?.href}
                              className={navClassName}
                              onMouseOver={() => {
                                category.sections.length > 0 ? setActiveNav(idx) : setActiveNav(null);
                              }}
                            >
                              {category?.text}
                            </a>
                          ))}
                      </>
                    ) : (
                      <HoverComponent
                        timer={700}
                        action={() => {
                          category.sections.length > 0 ? setActiveNav(idx) : setActiveNav(null);
                        }}
                      >
                        {isInternal ? (
                          <Link key={idx} to={internalPath} className={navClassName}>
                            {category?.text}
                          </Link>
                        ) : (
                          <a key={idx} href={category?.href} className={navClassName}>
                            {category?.text}
                          </a>
                        )}
                      </HoverComponent>
                    )}
                  </span>
                );
              })}
          </div>

          <div className={dropdownClass} onMouseLeave={ev => setActiveNav(null)}>
            {activeNav !== null &&
              categoryData &&
              categoryData?.sections?.map((section, sectionIdx) => {
                const headingInternalPath = getInternalPath(section?.heading?.href);
                const isHeadingInternal = !!headingInternalPath;
                return (
                  <div className="active section" key={sectionIdx}>
                    <div className="heading">
                      {isHeadingInternal ? (
                        <Link
                          className={`headingtitle ${
                            user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""
                          }`}
                          to={headingInternalPath}
                        >
                          {section?.heading?.text}
                        </Link>
                      ) : (
                        <a
                          className={`headingtitle ${
                            user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""
                          }`}
                          href={section?.heading?.href}
                        >
                          {section?.heading?.text}
                        </a>
                      )}
                    </div>

                    <ul className={`links ${user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""}`}>
                      {section?.links.map((link, linkIdx) => {
                        const linkInternalPath = getInternalPath(link?.href);
                        const isLinkInternal = !!linkInternalPath;
                        return (
                          <li key={linkIdx}>
                            <div className="line" />

                            {isLinkInternal ? (
                              <Link
                                className={`sublink ${
                                  user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""
                                }`}
                                to={linkInternalPath}
                              >
                                {link?.text}
                              </Link>
                            ) : (
                              <a
                                className={`sublink ${
                                  user.colors && user.colors.preset === "BlossomBytes" ? "blossom" : ""
                                }`}
                                href={link?.href}
                              >
                                {link?.text}
                              </a>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </Layout>
  );
};

export default SubNav;
